import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../graphql/types.generated';
export type NotificationsMarkAllAsReadMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.MarkAllAsReadInput;
}>;

export type NotificationsMarkAllAsReadMutationResult = { __typename?: 'Mutation' } & {
  notificationsMarkAllAsRead?: GraphQLTypes.Maybe<
    { __typename?: 'MarkAllAsReadPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message'>>>;
    }
  >;
};

export const NotificationsMarkAllAsReadDocument = gql`
  mutation notificationsMarkAllAsRead($input: MarkAllAsReadInput!) {
    notificationsMarkAllAsRead(input: $input) {
      errors {
        message
      }
    }
  }
`;
